const API_URL = import.meta.env.VITE_API_URL ?? 'http://localhost:8082';
const AUTH_URL = import.meta.env.VITE_AUTH_URL ?? 'https://64007810.propelauthtest.com';
const ENVIRONMENT = import.meta.env.VITE_WEXLER_ENV ?? 'local';
const FRONTEND_URL = import.meta.env.VITE_FRONTEND_URL ?? 'http://localhost:3030';
const TLDRAW_LICENSE_KEY = import.meta.env.VITE_TLDRAW_LICENSE_KEY ?? '';
const IS_DEV_MODE = import.meta.env.DEV ?? false;
const NOVU_APP_ID = import.meta.env.VITE_NOVU_APP_ID ?? 'cyVQbObzc4YQ';
const NOVU_BACKEND_URL = import.meta.env.VITE_NOVU_BACKEND_URL ?? 'http://localhost:3001';
const NOVU_SOCKET_URL = import.meta.env.VITE_NOVU_SOCKET_URL ?? 'http://localhost:3002';
const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN ?? '';
const AUTH_BYPASS = import.meta.env.VITE_AUTH_BYPASS === 'true';

export const EnvVars = {
  API_URL,
  AUTH_URL,
  ENVIRONMENT,
  FRONTEND_URL,
  IS_DEV_MODE,
  NOVU_APP_ID,
  NOVU_BACKEND_URL,
  NOVU_SOCKET_URL,
  SENTRY_DSN,
  TLDRAW_LICENSE_KEY,
  AUTH_BYPASS,
};
